import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AdminAddProduct from './AdminAddProduct';
import { List, ListItem, ListItemText, Box, Divider } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { printOrder } from "./PrintOrder";
import QuantityCounter from "../QuantityCounter";
import DeleteIcon from "@mui/icons-material/Delete";
import { UpdateOrder } from "../../utils/order";
import DealChip from "../DealChip";
import {
  getUnitPrice,
  calculateItemTotal,
  calculateCartTotal,
} from "../../helpers/cartPriceHelper";
import OrderPriceWithDiscount from "./OrderPriceWithDiscount";
import { calculateOrderDiscountSummary } from "../../helpers/orderDiscountHelper";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AdminEditProductDialog({ open, handleClose, order }) {



  const [localOrder, setLocalOrder] = useState(order);

  const handleOrderProductAmountChange = (orderProductId, newAmount) => {
    if (newAmount <= 0) {
      handleRemoveOrderProduct(orderProductId);
      return;
    }

    setLocalOrder(prev => ({
      ...prev,
      ordersProducts: prev.ordersProducts.map(item =>
        item.id === orderProductId
          ? { ...item, amount: newAmount }
          : item
      )
    }));
  };
 const handleSaveOrder = async () => {
  try {
    const discountSummary = calculateOrderDiscountSummary(localOrder);

    const updatedOrder = {
      ...localOrder,
      totalCost: discountSummary.finalTotal,
    };

    const res = await UpdateOrder(updatedOrder.id, updatedOrder);
    console.log("update order response:", res);

    alert("השינויים נשמרו בהצלחה");
    window.location.reload();
  } catch (err) {
    console.error(err);
    alert("שגיאה בשמירת ההזמנה");
  }
};

  const handleRemoveOrderProduct = (orderProductId) => {
    setLocalOrder(prev => ({
      ...prev,
      ordersProducts: prev.ordersProducts.filter(item => item.id !== orderProductId)
    }));
  };

  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

  const resolveImgSrc = (img) => {
    if (!img) return null;
    if (img instanceof File) return URL.createObjectURL(img);
    const path = String(img).replace(/\\/g, "/"); // ליתר ביטחון אם הגיעו backslashes
    if (path.startsWith("http") || path.startsWith("//")) return path;
    return `${API_BASE}${path}`; // הופך "/       /..." ל־"https://localhost:7010/uploads/..."
  };



  const handlePrint = () => {
    printOrder(order, resolveImgSrc);
  };

  const translateOptionType = (type) => {
    switch (type) {
      case "Color":
        return "צבע";
      case "Size":
        return "מידה";
      default:
        return type; // fallback אם יתווסף סוג בעתיד
    }
  };

  const calcTotal = (ordersProducts) => {
    return calculateCartTotal(ordersProducts);
  };

  const formatUserAddress = (user) => {
    const address = user?.userAddresses?.[0];

    if (!address) return "לא הוגדרה כתובת";

    return [
      address.city,
      `${address.street || ""} ${address.houseNumber || ""}`.trim(),
      address.apartment ? `דירה ${address.apartment}` : "",
      address.floor ? `קומה ${address.floor}` : "",
      address.entrance ? `כניסה ${address.entrance}` : "",
      address.notes ? `הערות: ${address.notes}` : "",
    ]
      .filter(Boolean)
      .join(", ");
  };

  return (
    <>
      {/* <AdminAddProduct/> */}
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg" // אפשר "lg" אם את רוצה יותר גדול  

      >
        {/* .... */}

        <DialogTitle sx={{ m: 0, p: 2, position: "relative", pr: 6 }} id="customized-dialog-title">
          פרטי הזמנה

          <IconButton
            aria-label="print"
            onClick={handlePrint}
            sx={{
              position: 'absolute',
              left: 8,          // אם RTL, אפשר לשים ב-right: 8
              top: 8,
            }}
          >
            <PrintIcon />
          </IconButton>
        </DialogTitle>

        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <DialogContent dividers>
          <Box id={`order-print-${order.id}`}>
            {/* <Typography gutterBottom>
           {JSON.stringify(order)}
          </Typography> */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                פרטי לקוח
              </Typography>
              <Typography>שם: {order.user?.name}</Typography>
              <Typography>אימייל: {order.user?.email}</Typography>
              <Typography>טלפון: {order.user?.phone}</Typography>
              <Typography>
                כתובת: {order.shippingAddress || "לא הוגדרה כתובת להזמנה"}
              </Typography>
              <Typography variant="h6">
                שיטת משלוח: {order?.shippingMethod}
              </Typography>
            </Box>
            <Divider sx={{ mx: -2, my: 2, borderColor: "rgba(0,0,0,0.12)" }} />
            <List className="print-products-list">
              {localOrder.ordersProducts.map((orderProduct) => {
                const optionText = orderProduct.productOption
                  ? `${translateOptionType(orderProduct.productOption.optionType)}: ${orderProduct.productOption.value}`
                  : null;
                const displayImage =
                  orderProduct.productOption?.image || orderProduct.product?.image;

                console.log("order product:", orderProduct.product);



                return (
                  <React.Fragment key={orderProduct.id}>
                    <ListItem>
                      <Box
                        component="img"
                        src={resolveImgSrc(displayImage)}
                        alt={orderProduct.product?.name}
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: 1,
                          objectFit: "cover",
                          ml: 2,
                        }}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />

                      <ListItemText
                        primary={
                          <>
                            <>
                              <Box sx={{ display: "inline-flex", width: "fit-content" }}>
                                <DealChip product={orderProduct.product} />
                              </Box>

                              <Typography sx={{ fontWeight: 600 }}>
                                {orderProduct.product?.name}
                                {optionText && ` (${optionText})`}
                              </Typography>
                            </>

                          </>
                        }
                        secondary={(() => {
                          const unitPrice = getUnitPrice(orderProduct);
                          const amount = Number(orderProduct.amount) || 0;
                          const lineTotal = calculateItemTotal(orderProduct);

                          return `כמות: ${amount} × ${unitPrice.toFixed(2)} ש"ח | סה"כ: ${lineTotal.toFixed(2)} ש"ח`;
                        })()}

                        sx={{ ml: 2, textAlign: "right" }}
                      />
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <QuantityCounter
                          value={orderProduct.amount}
                          max={orderProduct.product?.quantity}
                          onChange={(newAmount) =>
                            handleOrderProductAmountChange(orderProduct.id, newAmount)
                          }
                        />

                        <IconButton
                          color="error"
                          onClick={() => handleRemoveOrderProduct(orderProduct.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </ListItem>
                  </React.Fragment>
                );
              })}
            </List>

            <Box sx={{ mt: 2, p: 2, borderTop: "1px solid #ddd" }}>
              <OrderPriceWithDiscount order={localOrder} showTitle={true} />
            </Box>

            {/* פרטי הזמנה ולקוח */}



          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            ביטול
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveOrder}
          >
            שמור שינויים
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}